import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconActivitySwimmingComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.6"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.57 12.87a1.76 1.76 0 0 1 2.89-.1c.99 1.26 2.37 2.48 4.54 2.48 2.2 0 3.57-.98 4.5-2.23.73-.96 2.3-1.12 3.05.02.62.95 1.3 1.7 2.62 2a.75.75 0 0 1-.34 1.46 5.57 5.57 0 0 1-3.54-2.63.28.28 0 0 0-.25-.13.43.43 0 0 0-.33.18A6.77 6.77 0 0 1 12 16.75c-2.84 0-4.61-1.64-5.72-3.06a.3.3 0 0 0-.25-.13.23.23 0 0 0-.2.11c-.74 1.16-1.7 2.37-3.66 2.83a.75.75 0 0 1-.34-1.46c1.4-.33 2.08-1.14 2.74-2.17ZM4.57 17.87a1.76 1.76 0 0 1 2.89-.1c.99 1.26 2.37 2.48 4.54 2.48 2.2 0 3.57-.98 4.5-2.23.73-.96 2.3-1.12 3.05.02.62.95 1.3 1.7 2.62 2a.75.75 0 0 1-.34 1.46 5.57 5.57 0 0 1-3.54-2.63.28.28 0 0 0-.25-.13.43.43 0 0 0-.33.18A6.77 6.77 0 0 1 12 21.75c-2.84 0-4.61-1.64-5.72-3.06a.3.3 0 0 0-.25-.13.23.23 0 0 0-.2.11c-.74 1.16-1.7 2.37-3.66 2.83a.75.75 0 0 1-.34-1.46c1.4-.33 2.08-1.14 2.74-2.17Z"
          fill="#0E3B43"
        />
        <path
          d="M8.44 4.63a.67.67 0 0 0-1.01.88l.98 1.15c.91 1.06.65 2.68-.55 3.4L4.4 12.14a.75.75 0 1 1-.78-1.28L7.1 8.77c.4-.24.49-.78.18-1.13L6.3 6.49a2.17 2.17 0 0 1 3.27-2.85l6.5 7.36a.75.75 0 0 1-1.12 1l-6.5-7.37ZM17 3.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM13.75 5.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Z"
          fill="#0E3B43"
        />
      </svg>
    </SvgIcon>
  );
};

IconActivitySwimmingComponent.displayName = 'IconActivitySwimming';

const IconActivitySwimming = React.memo(IconActivitySwimmingComponent);

export default IconActivitySwimming;
